import React from 'react'
import {
  DateInput,
  Filter,
  NumberInput,
  SelectInput,
  TextInput,
} from 'react-admin'
import { APIEntity } from 'services/api/entities'
import {
  filterConfig,
  FilterInputType,
  FiltersCfg,
  FILTER_SOURCES,
} from 'services/cfg/filter'
import TailoredOrganizationFilter from './WrappedInputs/TailoredFilters/TailoredOrganizationFilter'
import { WithEntity } from 'resources/catalog/packages/types'
import { ValueOf } from 'services/utils'
import TailoredClientFilter from './WrappedInputs/TailoredFilters/TailoredClientFilter'
import { TailoredVisibleToAllFilter } from './WrappedInputs/TailoredFilters/TailoredVisibleToAllFilter'
import { useKResource } from 'services/hooks/useKResource'

type Props = {
  resource?: APIEntity
}

type FilterInputComponentType =
  | typeof DateInput
  | typeof NumberInput
  | typeof TextInput
  | typeof TailoredClientFilter
  | typeof TailoredOrganizationFilter
  | typeof SelectInput
  | typeof TailoredVisibleToAllFilter

const FILTER_FIELDS_MAP: Record<FilterInputType, FilterInputComponentType> = {
  date: DateInput,
  number: NumberInput,
  text: TextInput,
  organizationFilter: TailoredOrganizationFilter,
  select: SelectInput,
  clientFilter: TailoredClientFilter,
  visibleToAll: TailoredVisibleToAllFilter,
}

export type KFilterFieldProps = WithEntity & {
  label: string
  source: ValueOf<typeof FILTER_SOURCES>
  alwaysOn?: boolean
  key: number
}

const KFilters = (props: Props) => {
  const resource = useKResource()

  if (!resource) return null
  const filters: FiltersCfg[] = filterConfig[resource] ?? []

  const mappedFilters = filters.map((filter, idx) => {
    const Field = FILTER_FIELDS_MAP[filter.inputField]

    return (
      <Field
        {...filter.additionalProps}
        entity={resource}
        label={filter.label}
        source={filter.source}
        alwaysOn={filter.displayAlways}
        key={idx}
      />
    )
  })
  return <Filter {...props}>{mappedFilters}</Filter>
}

export default KFilters
